
    <div class="content">
    <div *ngIf="!isCustomHeader">
      <div class="close" (click)="onCancelContextPopup()"></div>
      <h3>{{title}}</h3>
      <div class="divider"></div>
    </div>
    <ng-content></ng-content>
    </div>
  